import React from 'react'
import Typewriter from 'typewriter-effect';
import '../styles/Home.scss';
import { Breakpoint } from 'react-socks';
import Sidebar from './Sidebar';
import { Button } from '@material-ui/core';
import { Link } from 'react-scroll';

function Home() {
  return (
    <div>
      <Breakpoint medium up>
        <div className='home'>
          <div className='home-left'>
            <h1 className='home-intro'>Hey,</h1>
            <h1 className='home-intro'>I'm Vincent,</h1>
            <h1 className='home-intro'>
              <Typewriter
                options={{
                  strings: ['a developer.', 'a creator.', 'a learner.', 'a musician.', 'a friend.'],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 45,
                  delay: 45
                }} 
              />
            </h1>
            <div>
            <Link
                activeClass='active'
                to='about'
                spy={true}
                smooth={true}
                offset={-10}
                duration={500}
              >
              <Button className='home-button'>See more</Button>
              </Link>
            </div>

          </div>
        </div>
      </Breakpoint>
      <Breakpoint small down>
      <div className='home'>
          <div className='home-left'>
            <h1 className='home-intro'>Hey,</h1>
            <h1 className='home-intro'>I'm Vincent,</h1>
            <h1 className='home-intro'>
              <Typewriter
                options={{
                  strings: ['a developer.', 'a creator.', 'a learner.', 'a musician.', 'a friend.'],
                  autoStart: true,
                  loop: true,
                  deleteSpeed: 45,
                  delay: 45
                }} 
              />
            </h1>
            <div>
              <Button className='home-button'>See more</Button>
            </div>

          </div>
        </div>

      </Breakpoint>
    </div>
  )
}

export default Home
